import { render, staticRenderFns } from "./pay_order.vue?vue&type=template&id=2563c967&scoped=true"
import script from "./pay_order.vue?vue&type=script&lang=js"
export * from "./pay_order.vue?vue&type=script&lang=js"
import style0 from "./pay_order.vue?vue&type=style&index=0&id=2563c967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563c967",
  null
  
)

export default component.exports